/**
 * Removes properties with falsy values from an object.
 */
export function removeFalsyProperties<T extends object>(obj: T): T {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value),
  ) as T;
}
